import { Box, Container, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "../../../explorer/hooks/useTranslation";

type TWarrantyBasketItemsHeader = {};

const WarrantyBasketItemsHeader: FC<TWarrantyBasketItemsHeader> = (props) => {
    const {} = props;
    const { t } = useTranslation();
    return (
        <Container
            sx={{
                display: "flex",
                flexGrow: 1,
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            <Box sx={{ width: 300 }}>
                <Typography variant="body1">
                    {t("common.spareparts.part.codeDescription")}
                </Typography>
            </Box>
            <Box sx={{ width: 150 }}>{""}</Box>
            <Box sx={{ width: 150, textAlign: "center" }}>
                <Typography>
                    {t("common.spareparts.part.avaibility")}
                </Typography>
            </Box>
            <Box sx={{ width: 150, textAlign: "center" }}>
                <Typography>{t("common.spareparts.part.qty")}</Typography>
            </Box>
            <Box sx={{ width: 150, textAlign: "right" }}>
                <Typography>
                    {t("common.spareparts.part.grossUnitPrice")}
                </Typography>
            </Box>
            <Box sx={{ width: 150, textAlign: "right" }}>
                <Typography>
                    {t("common.spareparts.part.netTotalPrice")}
                </Typography>
            </Box>
        </Container>
    );
};
export default WarrantyBasketItemsHeader;
